module.exports = __webpack_public_path__ + "static/media/priest_framed1.911f3d20.png";